"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialScrollToBottom = void 0;
var react_1 = require("react");
/**
 * Hook to scroll to bottom on initial message load, resetting when session changes.
 *
 * @param containerRef - Ref to the scrollable container
 * @param messagesLength - Current number of messages (triggers scroll when > 0)
 * @param sessionId - Session identifier (resets scroll tracking when it changes)
 * @param isStreaming - Whether currently streaming (skips scroll if messages from streaming)
 */
// eslint-disable-next-line import/prefer-default-export
var useInitialScrollToBottom = function (containerRef, messagesLength, sessionId, isStreaming) {
    var hasScrolled = (0, react_1.useRef)(false);
    // Track if streaming was ever active - if so, messages came from streaming, not history
    var wasStreamingRef = (0, react_1.useRef)(false);
    var scrollToBottom = (0, react_1.useCallback)(function () {
        if (containerRef.current) {
            // eslint-disable-next-line no-param-reassign
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [containerRef]);
    // Track when streaming becomes active - messages from streaming should not trigger initial scroll
    (0, react_1.useEffect)(function () {
        if (isStreaming) {
            wasStreamingRef.current = true;
        }
    }, [isStreaming]);
    // Scroll to bottom on initial message load (from history only, not from streaming)
    (0, react_1.useEffect)(function () {
        // Skip if messages came from streaming (not loading history)
        if (wasStreamingRef.current) {
            return;
        }
        if (messagesLength > 0 && !hasScrolled.current) {
            requestAnimationFrame(function () {
                scrollToBottom();
                hasScrolled.current = true;
            });
        }
    }, [messagesLength, scrollToBottom]);
    // Reset when session changes, but NOT if we're mid-stream
    // (Session ID is assigned mid-stream for new conversations, so we must not reset wasStreamingRef)
    (0, react_1.useEffect)(function () {
        if (!isStreaming) {
            hasScrolled.current = false;
            wasStreamingRef.current = false;
        }
    }, [sessionId, isStreaming]);
};
exports.useInitialScrollToBottom = useInitialScrollToBottom;
